/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JumboGetedrmachinesCriticalIssuesType = {
    TamperProtectionDisabled: 'tamper_protection_disabled',
    AntivirusDisabled: 'antivirus_disabled',
    UnhealthyEdrStatus: 'unhealthy_edr_status'
} as const;
export type JumboGetedrmachinesCriticalIssuesType = typeof JumboGetedrmachinesCriticalIssuesType[keyof typeof JumboGetedrmachinesCriticalIssuesType];


export function JumboGetedrmachinesCriticalIssuesTypeFromJSON(json: any): JumboGetedrmachinesCriticalIssuesType {
    return JumboGetedrmachinesCriticalIssuesTypeFromJSONTyped(json, false);
}

export function JumboGetedrmachinesCriticalIssuesTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetedrmachinesCriticalIssuesType {
    return json as JumboGetedrmachinesCriticalIssuesType;
}

export function JumboGetedrmachinesCriticalIssuesTypeToJSON(value?: JumboGetedrmachinesCriticalIssuesType | null): any {
    return value as any;
}

